import { chakra, Flex } from "@chakra-ui/react";
import Agreement from "@/pages/agreement/TwDoc";
import Privacypolicy from "@/pages/privacypolicy/TwDoc";

const Wrap = chakra(Flex, {
  baseStyle: {
    color: "#010313",
    flexDirection: "column",
    gap: "10px",
  },
});
const EnDc = () => {
  return (
    <Wrap>
      <Agreement />
      <Privacypolicy />
    </Wrap>
  );
};

export default EnDc;
